module.exports = __webpack_public_path__ + "static/media/money.d7e6e8bc.png";